import {
  CreateTaskMutationVariables,
  TaskAttributes,
  TaskMemberRoleAttributes,
} from '@graphql/generated';
import {
  AssignTaskSourceCard,
  sourceCardCreateVariables,
} from '@utils/tasks/assignTaskSourceCard';

/**
 * Builds the createTask variables for TaskFormStack's create path.
 *
 * In the chat assign flow (`isAssignTask`) no task members are sent: the
 * picked members are assigned by the follow-up assignTaskUsers instead.
 *
 * TA-11182: when the flow was opened from a MEMBER JOINED card, createTask
 * sends the TASK ASSIGNED card in the DM itself, so it must also get the card
 * to replace as `sourceMessageId`; otherwise both cards stay. `sourceCard` is
 * a required key so a call site cannot drop it silently.
 */
export const buildCreateTaskVariables = ({
  attributes,
  taskMembers,
  isAssignTask,
  chatId,
  sourceCard,
}: {
  attributes: Omit<TaskAttributes, 'taskMembers'>;
  taskMembers: TaskMemberRoleAttributes[];
  isAssignTask?: boolean;
  chatId?: string;
  sourceCard: AssignTaskSourceCard | undefined;
}): CreateTaskMutationVariables => ({
  attributes: {
    ...attributes,
    taskMembers: isAssignTask ? [] : taskMembers,
  },
  ...(chatId && { chatId }),
  // The follow-up assignTaskUsers still sends the card too; the backend
  // skips the swap once the card is gone.
  ...sourceCardCreateVariables({
    sourceCard,
    chatId,
    taskProjectId: attributes.projectId,
    // TaskModal only forwards the card for a chat known to be a DM.
    isGroupChat: false,
  }),
});
